module.exports = __webpack_public_path__ + "assets/Space-suit2.6ace3a0d.svg";